export default {
  methods: {
    Commafy(number) {
      let floated = parseFloat(number)
      var str = floated.toString().split('.');
      if (str[0].length > 0) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        return str.join('.');
      }
    }
  }
}
